import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Size2b01934yxlz5f as Size,
  Companion_getInstance37y5uk6rnmz38 as Companion_getInstance,
} from '../../models/Rect.mjs';
import { get_native16zxqjg6lrtlz as get_native } from '../NativeElement.commonHtml.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  measureByDuplicate50c5johgli0l as measureByDuplicate,
  resizeObserver1rxn81hcox9er as resizeObserver,
  mutationObserver1idzofyamtyii as mutationObserver,
} from './helpers.commonHtml.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeLinearLayoutElement1dab1ox1m83nf as NativeLinearLayoutElement } from './LinearLayouts.commonHtml.mjs';
import { AllFull_instancentf5l2xyg2jp as AllFull_instance } from './ProgrammaticLayout.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_px1lajc6xaddk2r as get_px,
  get_viewUnits3uus4yl4di64 as get_viewUnits,
} from '../../models/data.js.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../models/data.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function remeasureConstrainedSize($this) {
  var tmp = $this.native_1.element_1;
  var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var element = tmp_0;
  var tmp_1 = element.parentElement;
  var tmp1_elvis_lhs = tmp_1 instanceof HTMLElement ? tmp_1 : null;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var parentElement = tmp_2;
  var tmp2_safe_receiver = $this.log_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.log_iyb52q_k$(['Remeasuring the parent element constraint']);
  }
  $this.lastConstraintParentWidth_1 = parentElement.clientWidth;
  $this.lastConstraintParentHeight_1 = parentElement.clientHeight;
  var tmp_3 = $this;
  // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
  var tmp_4 = $this.native_1.style_1.native_1.flexGrow;
  var tmp3_safe_receiver = (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : null;
  var tmp_5;
  if (tmp3_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_6;
    if (!isBlank(tmp3_safe_receiver)) {
      tmp_6 = tmp3_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  tmp_3.definedFlexGrow_1 = tmp_5;
  var tmp_7 = $this;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var tmp_8 = $this.native_1.style_1.native_1.width;
  var tmp4_safe_receiver = (!(tmp_8 == null) ? typeof tmp_8 === 'string' : false) ? tmp_8 : null;
  var tmp_9;
  if (tmp4_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_10;
    if (!(tmp4_safe_receiver === $this.enforcedWidth_1 || isBlank(tmp4_safe_receiver))) {
      tmp_10 = tmp4_safe_receiver;
    } else {
      tmp_10 = null;
    }
    tmp_9 = tmp_10;
  }
  tmp_7.definedWidth_1 = tmp_9;
  var tmp_11 = $this;
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var tmp_12 = $this.native_1.style_1.native_1.height;
  var tmp5_safe_receiver = (!(tmp_12 == null) ? typeof tmp_12 === 'string' : false) ? tmp_12 : null;
  var tmp_13;
  if (tmp5_safe_receiver == null) {
    tmp_13 = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_14;
    if (!(tmp5_safe_receiver === $this.enforcedHeight_1 || isBlank(tmp5_safe_receiver))) {
      tmp_14 = tmp5_safe_receiver;
    } else {
      tmp_14 = null;
    }
    tmp_13 = tmp_14;
  }
  tmp_11.definedHeight_1 = tmp_13;
  var parentIsFlex = contains(parentElement.style.display, 'flex') === true;
  var parentIsVertical = contains(parentElement.style.flexDirection, 'col') === true;
  // Inline function 'kotlin.text.isNotBlank' call
  var this_0 = element.style.flexGrow;
  var elementHasGrow = !isBlank(this_0);
  var elementIsStretch = element.style.alignSelf === 'stretch' || isBlank(element.style.alignSelf);
  var tmp_15 = $this;
  var tmp_16;
  if (parentIsFlex && (parentIsVertical && elementHasGrow) || (!parentIsVertical && elementIsStretch)) {
    tmp_16 = true;
  } else {
    var tmp6_safe_receiver = $this.definedWidth_1;
    tmp_16 = (tmp6_safe_receiver == null ? null : contains(tmp6_safe_receiver, '100%')) === true;
  }
  tmp_15.lastFillWidth_1 = tmp_16;
  var tmp_17 = $this;
  var tmp_18;
  if (parentIsFlex && (!parentIsVertical && elementHasGrow) || (parentIsVertical && elementIsStretch)) {
    tmp_18 = true;
  } else {
    var tmp7_safe_receiver = $this.definedHeight_1;
    tmp_18 = (tmp7_safe_receiver == null ? null : contains(tmp7_safe_receiver, '100%')) === true;
  }
  tmp_17.lastFillHeight_1 = tmp_18;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var tmp_19 = $this.native_1.style_1.native_1.width;
  if (((!(tmp_19 == null) ? typeof tmp_19 === 'string' : false) ? tmp_19 : null) == $this.enforcedWidth_1) {
    if (parentIsFlex && !parentIsVertical) {
      // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
      $this.native_1.style_1.native_1.flexGrow = '999';
      // Inline function 'com.lightningkite.kiteui.views.width' call
      $this.native_1.style_1.native_1.width = 'unset';
    } else {
      // Inline function 'com.lightningkite.kiteui.views.width' call
      $this.native_1.style_1.native_1.width = '100%';
    }
  }
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var tmp_20 = $this.native_1.style_1.native_1.height;
  if (((!(tmp_20 == null) ? typeof tmp_20 === 'string' : false) ? tmp_20 : null) == $this.enforcedHeight_1) {
    if (parentIsFlex && parentIsVertical) {
      // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
      $this.native_1.style_1.native_1.flexGrow = '999';
      // Inline function 'com.lightningkite.kiteui.views.height' call
      $this.native_1.style_1.native_1.height = 'unset';
    } else {
      // Inline function 'com.lightningkite.kiteui.views.height' call
      $this.native_1.style_1.native_1.height = '100%';
    }
  }
  $this.lastConstraintSize_1 = new (Size())(element.clientWidth, element.clientHeight);
  var tmp0 = $this.native_1.style_1;
  var tmp8_elvis_lhs = $this.definedWidth_1;
  // Inline function 'com.lightningkite.kiteui.views.width' call
  var value = tmp8_elvis_lhs == null ? 'unset' : tmp8_elvis_lhs;
  tmp0.native_1.width = value;
  var tmp0_0 = $this.native_1.style_1;
  var tmp9_elvis_lhs = $this.definedHeight_1;
  // Inline function 'com.lightningkite.kiteui.views.height' call
  var value_0 = tmp9_elvis_lhs == null ? 'unset' : tmp9_elvis_lhs;
  tmp0_0.native_1.height = value_0;
  var tmp0_1 = $this.native_1.style_1;
  var tmp10_elvis_lhs = $this.definedFlexGrow_1;
  // Inline function 'com.lightningkite.kiteui.views.flexGrow' call
  var value_1 = tmp10_elvis_lhs == null ? 'unset' : tmp10_elvis_lhs;
  tmp0_1.native_1.flexGrow = value_1;
}
function ProgrammaticLayout$nativeAddChild$lambda(it) {
  // Inline function 'kotlin.js.asDynamic' call
  it.__existingMeasure = null;
  return Unit_instance;
}
function ProgrammaticLayout$nativeAddChild$lambda$lambda(it) {
  // Inline function 'kotlin.js.asDynamic' call
  it.__existingMeasure = null;
  return Unit_instance;
}
var ProgrammaticLayout$inProgress$1Class;
function ProgrammaticLayout$inProgress$1() {
  if (ProgrammaticLayout$inProgress$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.this$0__1 = this$0;
      }
      get_gap_18j5ar_k$() {
        return this.this$0__1.spacingCurrentPx_1;
      }
      get_paddingTop_iol9mb_k$() {
        return this.this$0__1.paddingTopCurrentPx_1;
      }
      get_paddingLeft_axk5v5_k$() {
        return this.this$0__1.paddingLeftCurrentPx_1;
      }
      get_paddingRight_gckk44_k$() {
        return this.this$0__1.paddingRightCurrentPx_1;
      }
      get_paddingBottom_24qann_k$() {
        return this.this$0__1.paddingBottomCurrentPx_1;
      }
      measure_lv46sz_k$(child, sizeConstraint) {
        var tmp = get_native(child).element_1;
        var tmp0_elvis_lhs = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return new (Size())(0.0, 0.0);
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var e = tmp_0;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_1 = e.__existingMeasure;
        var existing = tmp_1 instanceof Size() ? tmp_1 : null;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = e.__existingMeasureConstraint;
        var existingConstraint = tmp_2 instanceof Size() ? tmp_2 : null;
        if (!(existing == null) && equals(existingConstraint, sizeConstraint))
          return existing;
        var m = measureByDuplicate(e, sizeConstraint);
        // Inline function 'kotlin.js.asDynamic' call
        e.__existingMeasure = m;
        // Inline function 'kotlin.js.asDynamic' call
        e.__existingMeasureConstraint = sizeConstraint;
        return m;
      }
      place_lp1sg6_k$(child, left, top, right, bottom) {
        var tmp;
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.js.asDynamic' call
        if (child.__last_left == left) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp_1 = child.__last_top == top;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = child.__last_right == right;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = child.__last_bottom == bottom;
        } else {
          tmp = false;
        }
        if (tmp) {
          return Unit_instance;
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForStyle' call
        var tmp_2 = get_native(child).element_1;
        var tmp0_safe_receiver = tmp_2 instanceof HTMLElement ? tmp_2 : null;
        var tmp_3;
        if (tmp0_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForStyle' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp_4 = tmp0_safe_receiver.__suppressMutationObserverStyle;
          var tmp0_elvis_lhs = tmp_4 instanceof ArrayList() ? tmp_4 : null;
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            var n = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            // Inline function 'kotlin.js.asDynamic' call
            tmp0_safe_receiver.__suppressMutationObserverStyle = n;
            tmp_5 = n;
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          var e = tmp_5;
          var tmp0 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.position' call
          var value = 'absolute';
          tmp0.native_1.position = value;
          var tmp0_0 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.left' call
          var value_0 = left.toString() + 'px';
          tmp0_0.native_1.left = value_0;
          var tmp0_1 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.top' call
          var value_1 = top.toString() + 'px';
          tmp0_1.native_1.top = value_1;
          var tmp0_2 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_2 = (right - left).toString() + 'px';
          tmp0_2.native_1.width = value_2;
          var tmp0_3 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_3 = (bottom - top).toString() + 'px';
          tmp0_3.native_1.height = value_3;
          var tmp1_elvis_lhs = tmp0_safe_receiver.getAttribute('style');
          e.add_utx5q5_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          tmp_3 = Unit_instance;
        }
        if (tmp_3 == null) {
          var tmp0_4 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.position' call
          var value_4 = 'absolute';
          tmp0_4.native_1.position = value_4;
          var tmp0_5 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.left' call
          var value_5 = left.toString() + 'px';
          tmp0_5.native_1.left = value_5;
          var tmp0_6 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.top' call
          var value_6 = top.toString() + 'px';
          tmp0_6.native_1.top = value_6;
          var tmp0_7 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.width' call
          var value_7 = (right - left).toString() + 'px';
          tmp0_7.native_1.width = value_7;
          var tmp0_8 = get_native(child).style_1;
          // Inline function 'com.lightningkite.kiteui.views.height' call
          var value_8 = (bottom - top).toString() + 'px';
          tmp0_8.native_1.height = value_8;
        }
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_left = left;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_top = top;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_right = right;
        // Inline function 'kotlin.js.asDynamic' call
        child.__last_bottom = bottom;
      }
    }
    initMetadataForClass($);
    ProgrammaticLayout$inProgress$1Class = $;
  }
  return ProgrammaticLayout$inProgress$1Class;
}
var ProgrammaticLayoutClass;
function ProgrammaticLayout() {
  if (ProgrammaticLayoutClass === VOID) {
    class $ extends NativeLinearLayoutElement() {
      constructor(context) {
        super(context);
        this.native_1.tag_1 = 'div';
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'relative';
        tmp0.native_1.position = value;
        this.delegate_1 = AllFull_instance;
        this.log_1 = null;
        this.spacingCurrentPx_1 = 0.0;
        this.paddingTopCurrentPx_1 = 0.0;
        this.paddingLeftCurrentPx_1 = 0.0;
        this.paddingRightCurrentPx_1 = 0.0;
        this.paddingBottomCurrentPx_1 = 0.0;
        var tmp = this;
        tmp.inProgress_1 = new (ProgrammaticLayout$inProgress$1())(this);
        this.definedFlexGrow_1 = null;
        this.definedWidth_1 = null;
        this.definedHeight_1 = null;
        this.enforcedWidth_1 = null;
        this.enforcedHeight_1 = null;
        this.lastConstraintParentWidth_1 = 0;
        this.lastConstraintParentHeight_1 = 0;
        this.lastConstraintSize_1 = Companion_getInstance().Zero_1;
        this.renderSize_1 = Companion_getInstance().Zero_1;
        this.lastFillWidth_1 = true;
        this.lastFillHeight_1 = true;
        this.timeoutSet_1 = false;
        this.currentSize_1 = Companion_getInstance().Zero_1;
      }
      set_delegate_q5h9as_k$(value) {
        this.delegate_1 = value;
        this.invalidateLayout_x80ubv_k$();
      }
      onStartup_vrxh3i_k$() {
        super.onStartup_vrxh3i_k$();
        var tmp = resizeObserver(get_native(ensureNotNull(this.get_parent_hy4reb_k$())));
        onRemove(this, tmp.addListener_6y9mct_k$(() => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['resizeObserver calls invalidateLayout()']);
          }
          remeasureConstrainedSize(this);
          this.invalidateLayout_x80ubv_k$();
          return Unit_instance;
        }));
      }
      nativeAddChild_hge4nv_k$(index, element) {
        super.nativeAddChild_hge4nv_k$(index, element);
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var this_0 = get_native(element);
        var tmp0_safe_receiver = this_0.element_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp0_safe_receiver.__existingMeasure = null;
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this_0.elementToDo_1.add_utx5q5_k$(ProgrammaticLayout$nativeAddChild$lambda);
        }
        var tmp0 = get_native(element).style_1;
        // Inline function 'com.lightningkite.kiteui.views.position' call
        var value = 'absolute';
        tmp0.native_1.position = value;
        var tmp_0 = mutationObserver(get_native(element), true);
        onRemove(element, tmp_0.addListener_6y9mct_k$(() => {
          // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
          var this_0 = get_native(element);
          var tmp0_safe_receiver = this_0.element_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp0_safe_receiver.__existingMeasure = null;
            tmp = Unit_instance;
          }
          if (tmp == null) {
            this_0.elementToDo_1.add_utx5q5_k$(ProgrammaticLayout$nativeAddChild$lambda$lambda);
          }
          var tmp_0;
          if (this.timeoutSet_1) {
            return Unit_instance;
          }
          var tmp0_safe_receiver_0 = this.log_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.log_iyb52q_k$(['child mutation calls invalidateLayout()']);
          }
          this.invalidateLayout_x80ubv_k$();
          return Unit_instance;
        }));
        var tmp0_safe_receiver_0 = this.log_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.log_iyb52q_k$(['child insert calls invalidateLayout()']);
        }
        this.invalidateLayout_x80ubv_k$();
      }
      nativeRemoveChild_8vu7sp_k$(index) {
        super.nativeRemoveChild_8vu7sp_k$(index);
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['child remove calls invalidateLayout()']);
        }
        this.invalidateLayout_x80ubv_k$();
      }
      get_gap_83dt6d_k$() {
        return super.get_gap_83dt6d_k$();
      }
      nativeApplyTheme_6heplg_k$(theme) {
        super.nativeApplyTheme_6heplg_k$(theme);
        var tmp = this;
        var tmp0_safe_receiver = this.get_gap_83dt6d_k$();
        var tmp_0;
        var tmp_1 = tmp0_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = get_px(tmp0_safe_receiver);
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp.spacingCurrentPx_1 = tmp1_elvis_lhs == null ? get_px(theme.theme_1.gap_1) : tmp1_elvis_lhs;
      }
      refreshPadding_un7dm_k$() {
        super.refreshPadding_un7dm_k$();
        var value = this.get_appliedPadding_3m7h7h_k$();
        this.paddingTopCurrentPx_1 = get_viewUnits(value.top_1);
        this.paddingLeftCurrentPx_1 = get_viewUnits(value.left_1);
        this.paddingRightCurrentPx_1 = get_viewUnits(value.right_1);
        this.paddingBottomCurrentPx_1 = get_viewUnits(value.bottom_1);
      }
      nativeClearChildren_cy0j45_k$() {
        super.nativeClearChildren_cy0j45_k$();
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['children clear calls invalidateLayout()']);
        }
        this.invalidateLayout_x80ubv_k$();
      }
      invalidateLayout_x80ubv_k$() {
        var tmp0_safe_receiver = this.log_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.log_iyb52q_k$(['invalidateLayout()']);
        }
        if (this.timeoutSet_1)
          return Unit_instance;
        var tmp = window;
        tmp.setTimeout(() => {
          var tmp0_safe_receiver = this.log_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(['invalidateLayout timeout']);
          }
          var tmp = this.native_1.element_1;
          var element = tmp instanceof HTMLElement ? tmp : null;
          var tmp_0 = element == null ? null : element.parentElement;
          var parentElement = tmp_0 instanceof HTMLElement ? tmp_0 : null;
          var tmp_1;
          if (element == null || parentElement == null) {
            this.timeoutSet_1 = false;
            return Unit_instance;
          }
          var tmp_2;
          if (this.lastConstraintSize_1.equals(Companion_getInstance().Zero_1)) {
            remeasureConstrainedSize(this);
            tmp_2 = Unit_instance;
          }
          this.currentSize_1 = this.lastConstraintSize_1;
          var natSize = this.delegate_1.measure_gjrpfh_k$(this, this.inProgress_1, this.lastConstraintSize_1);
          var tmp_3;
          if (!this.lastFillWidth_1) {
            this.enforcedWidth_1 = roundToInt(natSize.width_1).toString() + 'px';
            element.style.width = ensureNotNull(this.enforcedWidth_1);
            tmp_3 = Unit_instance;
          }
          var tmp_4;
          if (!this.lastFillHeight_1) {
            this.enforcedHeight_1 = roundToInt(natSize.height_1).toString() + 'px';
            element.style.height = ensureNotNull(this.enforcedHeight_1);
            tmp_4 = Unit_instance;
          }
          var s = new (Size())(this.lastFillWidth_1 ? this.lastConstraintSize_1.width_1 : natSize.width_1, this.lastFillHeight_1 ? this.lastConstraintSize_1.height_1 : natSize.height_1);
          this.currentSize_1 = s;
          this.delegate_1.layout_cdpgg7_k$(this, this.inProgress_1, s);
          var tmp_5 = window;
          tmp_5.setTimeout(() => {
            this.timeoutSet_1 = false;
            return Unit_instance;
          }, 1);
          return Unit_instance;
        }, 1);
        this.timeoutSet_1 = true;
      }
    }
    initMetadataForClass($, 'ProgrammaticLayout');
    ProgrammaticLayoutClass = $;
  }
  return ProgrammaticLayoutClass;
}
//region block: exports
export {
  ProgrammaticLayout as ProgrammaticLayout96iub9zkgjmh,
};
//endregion

//# sourceMappingURL=ProgrammaticLayout.js.mjs.map
